module.exports = "/images/header-logo@2x.png?31705f968794a2c8ff6c6bb39d8567ec";